import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { GatewayService } from 'src/app/gateway.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-pxa-dialog',
  templateUrl: './pxa-dialog.component.html',
  styleUrls: ['./pxa-dialog.component.scss']
})
export class PxaDialogComponent implements OnInit {
  private destroy$ = new Subject<void>();

  operacion = 'createpxa';
  idRegla = '';

  grupoVal = new FormGroup({
    PRIORITY: new FormControl('', [Validators.required, Validators.min(1)]),
    EXCHANGE_ID: new FormControl(''),
    DEPARTMENT_CODE: new FormControl(''),
    SOURCE_APPLICATION: new FormControl(''),
    EMPLOYEE_ID: new FormControl(''),
    PXA: new FormControl('N', [Validators.required]),
    FR: new FormControl('N', [Validators.required]),
    AG: new FormControl('N', [Validators.required]),
    FR_URL: new FormControl(''),
    FR_MSG_CONSENT: new FormControl(''),
    FR_MSG_REJECT: new FormControl('')
  });

  constructor(
    private spinner: NgxSpinnerService,
    private dialogRef: MatDialogRef<PxaDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private gateway: GatewayService
  ) { }

  ngOnInit() {
    if (this.data.operacion == 'Editar') {
      this.operacion = 'editpxa';
      this.idRegla = this.data.regla.id;
      this.grupoVal.controls.PRIORITY.setValue(this.data.regla.priority);
      this.grupoVal.controls.EXCHANGE_ID.setValue(this.data.regla.exchange_id || '');
      this.grupoVal.controls.DEPARTMENT_CODE.setValue(this.data.regla.department_code || '');
      this.grupoVal.controls.SOURCE_APPLICATION.setValue(this.data.regla.source_application || '');
      this.grupoVal.controls.EMPLOYEE_ID.setValue(this.data.regla.employee_id || '');
      this.grupoVal.controls.PXA.setValue(this.data.regla.pxa || 'N');
      this.grupoVal.controls.FR.setValue(this.data.regla.fr || 'N');
      this.grupoVal.controls.AG.setValue(this.data.regla.ag || 'N');
      this.grupoVal.controls.FR_URL.setValue(this.data.regla.fr_url || '');
      this.grupoVal.controls.FR_MSG_CONSENT.setValue(this.data.regla.fr_msg_consent || '');
      this.grupoVal.controls.FR_MSG_REJECT.setValue(this.data.regla.fr_msg_reject || '');
    }
    this.actualizarValidadoresFR();
    this.grupoVal.controls.FR.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.actualizarValidadoresFR();
    });
  }

  actualizarValidadoresFR() {
    const campos = ['FR_URL', 'FR_MSG_CONSENT', 'FR_MSG_REJECT'];
    if (this.grupoVal.controls.FR.value === 'S') {
      campos.forEach(c => {
        this.grupoVal.controls[c].setValidators([Validators.required]);
        this.grupoVal.controls[c].updateValueAndValidity();
      });
    } else {
      campos.forEach(c => {
        this.grupoVal.controls[c].clearValidators();
        this.grupoVal.controls[c].updateValueAndValidity();
      });
    }
  }

  save() {
    this.spinner.show();
    const regla = {
      ID: this.idRegla,
      PRIORITY: this.grupoVal.controls.PRIORITY.value,
      EXCHANGE_ID: this.grupoVal.controls.EXCHANGE_ID.value || null,
      DEPARTMENT_CODE: this.grupoVal.controls.DEPARTMENT_CODE.value || null,
      SOURCE_APPLICATION: this.grupoVal.controls.SOURCE_APPLICATION.value || null,
      EMPLOYEE_ID: this.grupoVal.controls.EMPLOYEE_ID.value || null,
      PXA: this.grupoVal.controls.PXA.value,
      FR: this.grupoVal.controls.FR.value,
      AG: this.grupoVal.controls.AG.value,
      FR_URL: this.grupoVal.controls.FR_URL.value || null,
      FR_MSG_CONSENT: this.grupoVal.controls.FR_MSG_CONSENT.value || null,
      FR_MSG_REJECT: this.grupoVal.controls.FR_MSG_REJECT.value || null,
      USUARIO_ID: this.data.USUARIO_ID,
      USUARIO_NOMBRE: this.data.USUARIO_NOMBRE
    };

    this.gateway.save(this.operacion, regla).then((result) => {
      this.spinner.hide();
      this.dialogRef.close(true);
    }).catch((e) => {
      this.spinner.hide();
    });
  }

  onNoClick() {
    this.dialogRef.close(false);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
